<template>
  <AppIcon
    v-if="typeId === DATA_SOURCE_TYPES.POWER_BI"
    class="edsi-Icon"
    icon-name="power-bi"
    height="24"
    width="24"
  />
</template>

<script setup>
import { DATA_SOURCE_TYPES } from '@/utils/datasources'
import { includesValue } from '@/utils/prop-validators'

import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'ElementDataSourceIcon'
})

defineProps({
  typeId: {
    type: Number,
    validator: v => includesValue(v, { ...DATA_SOURCE_TYPES }),
    required: true
  }
})
</script>

<style lang="scss" scoped>
.edsi-Icon {
  flex-shrink: 0;
}
</style>
